'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlanCardDetailSection = function PlanCardDetailSection(_ref) {
    var customer = _ref.customer,
        isSubscriptionAdmin = _ref.isSubscriptionAdmin;

    if (!customer || !isSubscriptionAdmin) return null;

    var sources = customer.getIn(['sources', 'data']);
    var card = sources && sources.first();

    var cardBrand = card && card.get('brand') || 'Unknown type';
    var last4 = card && card.get('last4') || '••••';
    var cardNumber = '\u2022\u2022\u2022\u2022 \u2022\u2022\u2022\u2022 \u2022\u2022\u2022\u2022 ' + last4;

    return _react2.default.createElement(
        'section',
        null,
        _react2.default.createElement(
            'div',
            { className: 'detail' },
            _react2.default.createElement(
                'p',
                { className: 'section-title' },
                'You\'re paying via credit card'
            ),
            _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                    'span',
                    { className: 'paren' },
                    cardBrand,
                    ' (',
                    cardNumber,
                    ')'
                )
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'action' },
            _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                    _reactRouter.Link,
                    { to: '/account/card' },
                    'Update card details'
                )
            )
        )
    );
};

PlanCardDetailSection.propTypes = {
    customer: _propTypes2.default.object,
    isSubscriptionAdmin: _propTypes2.default.bool
};

exports.default = PlanCardDetailSection;


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/plan/pro/planSections/PlanCardDetailSection.js
// module id = 2071
// module chunks = 0